import React, { useEffect } from "react";
import R from "ramda";

import { useFeaturedEcards, usePills, useLoading } from "hooks";
import PillPresenter from "presenters/PillPresenter";
import MetaTags from "components/MetaTags";
import MainTitle from "components/MainTitle";
import LDJsonSchema from "components/LDJsonSchema";
import StarringYouClipsCarousel from "components/StarringYouClipsCarousel";
import Categories from "components/Categories";
import logoVertical from "assets/images/common/logo-vertical.png";
import { useRouter } from "hooks";

import StarringYou from "./components/StarringYou";
import useStyles from "./useStyles";
import Hero from "./components/Hero";
import FeaturedCategories from "./components/FeaturedCategories";

const Home = () => {
  const classes = useStyles();
  const { pathname } = useRouter();
  const { origin } = window.location;
  const url = `${origin}${pathname}`;

  const { loadFeaturedEcards, starringYouCards, starringYouClipCards } = useFeaturedEcards();
  const { loadPills, pills } = usePills();
  const featuredCategories = pills && R.pipe(R.sortBy(PillPresenter.rank), R.take(4))(pills);

  const { isNotFinished: isPendingFeaturedEcards, func: loadFeaturedEcardsWithLoading } = useLoading(
    loadFeaturedEcards,
  );

  const { isNotFinished: isPendingPills, func: loadPillsWithLoading } = useLoading(loadPills);

  const organizationSchema = {
    "@context": "http://schema.org",
    "@type": "Organization",
    url: "https://www.jibjab.com/",
    logo: `https://www.jibjab.com${logoVertical}`,
    sameAs: ["https://twitter.com/jibjab", "https://www.facebook.com/jibjab"],
  };

  useEffect(() => {
    Promise.all([loadFeaturedEcardsWithLoading(), loadPillsWithLoading()]);
  }, []);

  return (
    <div className={classes.root}>
      <StarringYouClipsCarousel items={starringYouClipCards} loading={isPendingFeaturedEcards} />
      <StarringYou items={starringYouCards} loading={isPendingFeaturedEcards} />
      <Hero />
      <FeaturedCategories items={featuredCategories} loading={isPendingPills} />
      <Categories />
      <LDJsonSchema schema={organizationSchema} />
      <MainTitle title={"eCards - Customize &amp; Send Funny Greeting Cards Online - JibJab"} />
      <MetaTags>
        <meta
          name="keywords"
          content="Jibjab Ecards, ecards, greetings, happy birthday, birthday ecards, holiday ecards, anniversary, funny egreetings, video ecards, funny ecard, free ecards, free e cards, funny ecards"
        />
        <meta
          name="description"
          content="Personalized eCards from JibJab for every occasion. Browse, customize, send funny greeting cards online for birthdays, holidays, valentines, thank yous &amp; more!"
        />
        <meta property="og:site_name" content="JibJab" />
        <meta property="og:url" content={url} />
        <meta property="og:type" content="website" />
        <meta property="og:title" content="Funny eCards - Send Custom Greeting Cards Online w/ JibJab!" />
        <meta
          property="og:description"
          content="Personalized eCards from JibJab for every occasion. Browse, customize, send funny greeting cards online for birthdays, holidays, valentines, thank yous &amp; more!"
        />
      </MetaTags>
    </div>
  );
};

export default Home;
